import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CompanyDto } from './al-company-v2.service';

export interface CompanyRequestDto {
	id: number;
	companyId: number;
	newSubCompanyName: string;
	userId: number;
	userEmail: string;
}

export interface CompanyRequestUpdateDto {
	id: number;
	companyId: number;
	newSubCompanyName: string;
	userId: number;
	userEmail: string;
}

@Injectable({
	providedIn: 'root'
})
export class AlCompanyRequestV2Service {
	url: string = 'v2/companyrequests';

	constructor(private http: HttpClient) {}

	// CRUD start
	public getAll(): Observable<CompanyRequestDto[]> {
		return this.http.get<CompanyRequestDto[]>(`${this.url}`);
	}

	public get(companyId: number): Observable<CompanyRequestDto> {
		return this.http.get<CompanyRequestDto>(`${this.url}/${companyId}`);
	}

	public put(company: CompanyRequestUpdateDto): Observable<CompanyRequestDto> {
		return this.http.put<CompanyRequestDto>(`${this.url}/${company.id}`, company);
	}
	// CRUD end

	public approve(request: CompanyRequestDto): Observable<void> {
		return this.http.post<void>(`${this.url}/${request.id}/approve`, undefined);
	}

	public reject(request: CompanyRequestDto): Observable<void> {
		return this.http.post<void>(`${this.url}/${request.id}/reject`, undefined);
	}

	public getAllPotentialUsers(): Observable<[]> {
		return this.http.get<[]>(`${this.url}/potentialUsers`);
	}

	public getAllPotentialCompanies(): Observable<CompanyDto[]> {
		return this.http.get<CompanyDto[]>(`${this.url}/potentialCompanies`);
	}
}
